import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    SimpleChanges, effect} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HelperService, IdentifierService } from 'merlin-core';
import { UserProfileObject, UserService } from 'merlin-library';
import { ToastrService } from 'ngx-toastr';
import { ActionError } from 'projects/clinician/src/app/my-account/services/my-account.model';
import { distinctUntilChanged } from 'rxjs-compat/operator/distinctUntilChanged';
import { LocalizationService } from 'src/core/utilitites/localization.service';
import { PatientTransferRequestClinicService } from '../../../services/patient-transfer-request-clinic.service';
import { FRANCE_COUNTRY_CODE } from 'projects/clinician/src/app/constants/france.constants';
import { USA_COUNTRY_CODE } from 'projects/clinician/src/app/constants/USA.constants';

@Component({
    selector: 'app-patient-details',
    templateUrl: './patient-details.component.html',
    styleUrls: ['./patient-details.component.scss'],
    standalone: false
})
export class PatientDetailsComponent implements OnInit {
    // @Input() public patientDeviceForm: UntypedFormGroup;
    // public patientDetailsForm: UntypedFormGroup;

    errorMsgs = [];
    isJapanseLocale: boolean = false;
    langCodes: any;
    genderCodes: any;
    isUSAClinic: boolean;
    isCountryFrance: boolean;
    isLifenParticipating: boolean;

    @Input() public patientDeviceForm: UntypedFormGroup;
    public patientDetailsForm: UntypedFormGroup;
    @Input() public dateLabel;
    @Input() public dropDownsList;
    @Input() public toggleValidation = true;
    @Input() public togglePatientIdValidation = true;
    @Input() public hasDefaultPatientData: boolean;
    @Output() public nameValueChange: EventEmitter<any> =
        new EventEmitter<any>();
    @Output() public patientNumberChange: EventEmitter<any> =
        new EventEmitter<any>();
    //isJapanseLocale = false;

    @Input() functionMode: string;
    @Input() displayMode: string;
    @Input() patRes: any;
    @Input() userProfile;

    public stringLabels = [
        "label.gb.patientdetailsbr",
        "label.gb.alternatefirstname",
        "label.gb.alternatelastname",
        "label.gb.firstname",
        "label.gb.pat_record_no",
        "label.gb.race",
        "label.gb.gender",
        "label.gb.middlename",
        "label.gb.Merlin.net_number",
        "label.gb.pat_prefer",
        "label.gb.lastname",
        "label.gb.clinic_loc",
        "label.gb.merlin_net_enrollment",
        "label.gb.date_of_birth",
        "label.gb.INSnumber_long",
        "label.gb.SSN",
        "label.gb.OID",
        "label.gb.firstname_long",
        "label.gb.date_of_birth_long",
        "label.gb.gender_long",
        "label.gb.givennames_long",
        "label.gb.birth_code_long",
        "label.gb.firstname_used_long",
        "label.gb.pat_prefers",
        "label.gb.lastname_long",
        "label.gb.clinic_loc",
        "label.gb.merlin_net_enrollment"
    ]

    public labels: Record<string, string>;

    constructor(
        private localizationService: LocalizationService,
        public identifierService: IdentifierService,
        private route: ActivatedRoute,
        private requestService: PatientTransferRequestClinicService,
        private helperService: HelperService,
        private toasterService: ToastrService,
        private userService: UserService
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.dropDownsList?.currentValue) {
            const dropDowns = changes.dropDownsList.currentValue;

            // Assign langCodes
            if (dropDowns.langCodes && dropDowns.langCodes.length > 0) {
                this.langCodes = dropDowns.langCodes.sort((a, b) => {
                    if (a.description < b.description) return -1;
                    else return 1;
                });
                this.parseCodeLabels(this.langCodes);
            }

            // Assign genderCodes
            if (dropDowns.genderCodes && dropDowns.genderCodes.length > 0) {
                this.genderCodes = dropDowns.genderCodes.sort((a, b) => {
                    if (a.description < b.description) return -1;
                    else return 1;
                });
                this.parseCodeLabels(this.genderCodes);
            }

            // Parse raceCodes
            if (dropDowns.raceCodes && dropDowns.raceCodes.length > 0) {
                dropDowns.raceCodes.sort((a, b) => a.codeId - b.codeId);
                this.parseCodeLabels(dropDowns.raceCodes);
            }
        }

        this.hasIns();
    }

    ngOnInit() {
        this.translateStrings();
        this.userService
            .getUserProfile(false)
            .subscribe((res: UserProfileObject) => {
                this.isCountryFrance =
                    res.clinicCountryCd === FRANCE_COUNTRY_CODE;
                this.isUSAClinic = res.clinicCountryCd === USA_COUNTRY_CODE;
                this.isJapanseLocale =
                    res.locale == 'ja_JP_USA' ||
                        res.locale == 'ja_JP_TUV' ||
                        res.locale == 'ja_JP_ANZ' ||
                        res.locale == 'ja_JP_JAP'
                        ? true
                        : false;
                this.isLifenParticipating = res.lifenParticipatingFlg;
            });
        this.patientDetailsForm = this.patientDeviceForm?.get(
            'patientDetails'
        ) as UntypedFormGroup;
        this.patientDetailsForm.get('oidNumber').disable();
        if (!(this.isLifenParticipating && this.isCountryFrance)) {
            this.patientDetailsForm.get('insNumber').disable();
        }
        this.patientDetailsForm.get('placeOfBirth').disable();
        this.patientDetailsForm
            ?.get('patientNum')
            .valueChanges.subscribe((change) => {
                this.patientNumberChange.emit(change);
            });
        this.patientDetailsForm
            ?.get('firstName')
            .valueChanges.subscribe((change) => {
                this.nameValueChange.emit(change);
            });
        this.patientDetailsForm
            ?.get('lastName')
            .valueChanges.subscribe((change) => {
                this.nameValueChange.emit(change);
            });
            this.patientDetailsForm
            ?.get('dateOfBirthStr')
            .valueChanges.subscribe((change) => {
                this.nameValueChange.emit(change);
            });
            this.patientDetailsForm
            ?.get('givenNames')
            .valueChanges.subscribe((change) => {
                this.nameValueChange.emit(change);
            });
            this.patientDetailsForm
            ?.get('usedGivenName')
            .valueChanges.subscribe((change) => {
                this.nameValueChange.emit(change);
            });
            this.patientDetailsForm
            ?.get('usedLastName')
            .valueChanges.subscribe((change) => {
                this.nameValueChange.emit(change);
            });
        // this.bindFieldsData();

        this.requestService.getPatientProfile().subscribe((data) => {
            if (
                !this.hasDefaultPatientData &&
                this.isAnExistingPatient(data?.patient)
            ) {
                this.patientDetailsForm
                    .get('firstName')
                    .patchValue(data?.patient?.firstName);
                this.patientDetailsForm
                    .get('patientNum')
                    .patchValue(data?.patient?.patientNum);
                this.patientDetailsForm
                    .get('raceCd')
                    .patchValue(String(data?.patient?.raceCd));
                this.patientDetailsForm
                    .get('middleName')
                    .patchValue(data?.patient?.middleName);
                this.patientDetailsForm
                    .get('merlinNetId')
                    .patchValue(data?.patient?.merlinNetId);
                this.patientDetailsForm
                    .get('genderCd')
                    .patchValue(String(data?.patient?.genderCd));
                this.patientDetailsForm
                    .get('lastName')
                    .patchValue(data?.patient?.lastName);
                this.patientDetailsForm
                    .get('locationId')
                    .patchValue(String(data?.patient?.locationId));
                this.patientDetailsForm
                    .get('languageCd')
                    .patchValue(String(data?.patient?.languageCd));
                this.patientDetailsForm
                    .get('dateOfBirthStr')
                    .patchValue(data?.patient?.dateOfBirthStr);
                this.patientDetailsForm
                    .get('enrollmentDate')
                    .patchValue(String(data?.patient?.enrollmentDate));
                this.patientDetailsForm
                    .get('altFirstName')
                    .patchValue(data?.patient?.altFirstName);
                this.patientDetailsForm
                    .get('altLastName')
                    .patchValue(data?.patient?.altLastName);
            } else {
                this.patientDetailsForm
                    .get('locationId')
                    .patchValue(String(data?.patient?.locationId));
                this.patientDetailsForm
                    .get('languageCd')
                    .patchValue(String(data?.patient?.languageCd));
            }
        });

        this.langCodes = this.dropDownsList?.langCodes;
        this.parseCodeLabels(this.langCodes);
        this.genderCodes = this.dropDownsList?.genderCodes;
        this.patientDetailsForm.get('insNumber').valueChanges.subscribe((insNumberval)=>{
            this.hasIns();
            if(insNumberval=='')
                this.patientDetailsForm.get('insNumber').patchValue(null);
        })

        this.parseCodeLabels(this.dropDownsList.raceCodes);
        if (this.dropDownsList.raceCodes && this.dropDownsList.raceCodes.length > 0) {
            this.dropDownsList.raceCodes.sort((a, b) => a.codeId - b.codeId);
        }
        this.parseCodeLabels(this.dropDownsList.genderCodes);
    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

    appendStringsToLabelList(listToAppend: string[]){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, listToAppend);
    }

    parseCodeLabels(codes){
        let stringsToAppend = [];
       if(!codes || codes.length == 0) return;
        for(let code of codes){
            stringsToAppend.push('data.Code.' + code.qualifier + '.Code_Desc.' + code.code);
        }
        this.appendStringsToLabelList(stringsToAppend);
    }

    hasIns() {
        if (this.patientDetailsForm) {
            const insNumberControl = this.patientDetailsForm.get('insNumber');
            const fieldsToToggle = ['firstName', 'lastName','dateOfBirthStr', 'givenNames', 'usedGivenName', 'usedLastName' ,'genderCd'];
            if (insNumberControl.value !== null) {
                fieldsToToggle.forEach(field => {
                    this.patientDetailsForm.get(field).disable();
                });
            } else {
                fieldsToToggle.forEach(field => {
                    this.patientDetailsForm.get(field).enable();
                });
            }
        }
    }

    translateTooltip(){
        return this.localizationService.generateLocalizedStr('label.gb.pat_det_tooltip', null, 'html');
    }

    translatePlaceHolder(): string {
        let key =
            this.dateLabel?.toUpperCase() == 'DD-MM-YYYY'
                ? 'label.gb.ddmmyyyy'
                : this.dateLabel?.toUpperCase() == 'MM-DD-YYYY'
                    ? 'label.gb.mmddyyyy'
                    : 'label.gb.yyyymmdd';
        return this.localizationService.generateLocalizedStr(key);
    }

    bindFieldsData() {
        this.requestService.getPatientProfile().subscribe(
            (data) => {
                if (this.isAnExistingPatient(data?.patient)) {
                    this.patientDetailsForm
                        .get('firstName')
                        .patchValue(data.patient.firstName);
                    this.patientDetailsForm
                        .get('patientNum')
                        .patchValue(data.patient.patientNum);
                    this.patientDetailsForm
                        .get('raceCd')
                        .patchValue(String(data.patient.raceCd));
                    this.patientDetailsForm
                        .get('middleName')
                        .patchValue(data.patient.middleName);
                    this.patientDetailsForm
                        .get('merlinNetId')
                        .patchValue(data.patient.merlinNetId);
                    this.patientDetailsForm
                        .get('genderCd')
                        .patchValue(String(data.patient.genderCd));
                    this.patientDetailsForm
                        .get('lastName')
                        .patchValue(data.patient.lastName);
                    this.patientDetailsForm
                        .get('locationId')
                        .patchValue(String(data.patient.locationId));
                    this.patientDetailsForm
                        .get('languageCd')
                        .patchValue(String(data.patient.languageCd));
                    this.patientDetailsForm
                        .get('dateOfBirthStr')
                        .patchValue(data.patient.dateOfBirthStr);
                    this.patientDetailsForm
                        .get('enrollmentDate')
                        .patchValue(String(data.patient.enrollmentDate));
                    this.patientDetailsForm
                        .get('altFirstName')
                        .patchValue(data.patient.altFirstName);
                    this.patientDetailsForm
                        .get('altLastName')
                        .patchValue(data.patient.altLastName);
                    this.patientDetailsForm
                        .get('givenNames')
                        .patchValue(data.patient.givenNames);
                    this.patientDetailsForm
                        .get('usedGivenName')
                        .patchValue(data.patient.usedGivenName);
                    this.patientDetailsForm
                        .get('usedLastName')
                        .patchValue(data.patient.usedLastName);
                    this.patientDetailsForm
                        .get('insNumber')
                        .patchValue(data.patient.insNumber);
                    this.patientDetailsForm
                        .get('franceSsn')
                        .patchValue(data.patient.franceSsn);
                    this.patientDetailsForm
                        .get('oidNumber')
                        .patchValue(data.patient.oidNumber);
                    this.patientDetailsForm
                        .get('placeOfBirth')
                        .patchValue(data.patient.placeOfBirth);
                } else {
                    this.patientDetailsForm
                        .get('locationId')
                        .patchValue(String(data.patient.locationId));
                    this.patientDetailsForm
                        .get('languageCd')
                        .patchValue(String(data.patient.languageCd));
                }
            },
            (err) => {
                console.log(err);
                if (err && err.actionErrors) {
                    this.showToaster(err.actionErrors);
                } else {
                    this.helperService.showErrorToastr(err);
                }
            }
        );

    }

    compareLocations(o1, o2) {
        return o1 == o2;
    }

    compareLang(l1, l2) {
        return l1 == l2;
    }

    compareRaces(o1, o2) {
        return o1 == o2;
    }

    displayEditUI() {
        if (this.functionMode == 'enroll') {
            return true;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'edit'
        ) {
            return true;
        } else {
            return false;
        }
    }

    displayViewUI() {
        if (this.functionMode == 'profile' && this.displayMode == 'view') {
            return true;
        } else {
            return false;
        }
    }

    getClinicLocation() {
        let patDevice = this.patRes.dropdowns?.locations.filter((dev) => {
            return dev.value == this.patRes.patient?.locationId;
        });
        if (typeof patDevice === 'undefined' || patDevice?.length == 0) {
            return '';
        } else {
            return patDevice[0]?.label;
        }
    }

    getRace() {
        let patRace = this.patRes.dropdowns?.raceCodes.filter((code) => {
            return code.codeId == this.patRes.patient?.raceCd;
        });
        if (!patRace) {
            return '';
        } else {
            const raceText = this.formatDDString(patRace[0]);
            return this.translate(raceText);
        }
    }

    getGender() {
        let patChamb = this.patRes.dropdowns?.genderCodes
            .filter((code) => {
                return code.codeId == this.patRes.patient?.genderCd;
            });
        if (!patChamb) {
            return '';
        } else {
            const genderText = this.formatDDString(patChamb[0]);
            return this.translate(genderText);
        }
    }

    getLang() {
        let patChamb = this.patRes.dropdowns?.langCodes.filter((code) => {
            return code.codeId == this.patRes.patient.languageCd;
        });
        if (!patChamb) {
            return '';
        } else {
            const langText = this.formatDDString(patChamb[0]);
            return this.translate(langText);
        }
    }

    translate(key: string) {
        return this.localizationService.generateLocalizedStr(key);
    }

    showToaster(actionErrors: ActionError[]) {
        this.errorMsgs = [];
        actionErrors.forEach((item) => {
            const allKeys = Object.keys(item.parameters ?? {});
            let message = this.localizationService.generateLocalizedStr(
                item.message
            );
            allKeys.forEach((key) => {
                const param = item.parameters[key].message;
                message = message.replace(`{${key}}`, param);
            });

            this.errorMsgs.push(message);
            const errorMsg = this.helperService.getErrorList(this.errorMsgs);
            if (actionErrors.length == this.errorMsgs.length) {
                this.toasterService.error(errorMsg, null, {
                    enableHtml: true,
                    disableTimeOut: true,
                    tapToDismiss: false,
                });
            }
        });
    }

    formatDDString(ddObj: any) {
        if (ddObj) {
            return this.localizationService.generateLocalizedStr(
                'data.Code.' + ddObj.qualifier + '.Code_Desc.' + ddObj.code
            );
        } else {
            return '';
        }
    }

    isAnExistingPatient(patient) {
        return patient?.patientId !== -1;
    }
}
